import { memo } from 'react';

import { I13nNav } from 'Components/I13n';

type Props = {
  startComponent?: React.ReactElement;
  endComponent?: React.ReactElement;
};

const TopNavBase = (props: Props) => {
  const { startComponent, endComponent } = props;

  return (
    <I13nNav className="W(100%) Pos(a) T(0)" i13nModel={{ label: 'TopNav' }}>
      <div className="CenterAlign H(--top-nav-bar-height) Bgc($c-ds-background-primary)">
        {startComponent}
        {endComponent}
      </div>
    </I13nNav>
  );
};

export default memo(TopNavBase);
